type CookieBanner = {
  banner?: HTMLElement | null
  consentView?: HTMLElement | null
  consentSettingsBtn?: HTMLElement | null
  consentDeclineBtn?: HTMLElement | null
  consentAcceptBtn?: HTMLElement | null
  settingsView?: HTMLElement | null
  settingsBackBtn?: HTMLElement | null
  settingsSaveBtn?: HTMLElement | null
  policyView?: HTMLElement | null
  policyBackBtn?: HTMLElement | null
  policyCloseBtn?: HTMLElement | null
  policyAcceptBtn?: HTMLElement | null
  cookieInfoToggleList?: NodeListOf<HTMLElement> | null
  policyLinkList?: NodeListOf<HTMLElement> | null
}

const consentGroups = ['required', 'functional', 'analytic']
const cookieBanner: CookieBanner = {}

const setupEventHandlers = () => {
  cookieBanner.banner = document.getElementById('cookie-banner')
  cookieBanner.consentView = document.getElementById('cookie-consent-view')
  cookieBanner.consentSettingsBtn = document.getElementById('cookie-consent-settings')
  cookieBanner.consentDeclineBtn = document.getElementById('cookie-consent-decline')
  cookieBanner.consentAcceptBtn = document.getElementById('cookie-consent-accept')
  cookieBanner.settingsView = document.getElementById('cookie-settings-view')
  cookieBanner.settingsSaveBtn = document.getElementById('cookie-settings-save')
  cookieBanner.settingsBackBtn = document.getElementById('cookie-settings-back')
  cookieBanner.policyView = document.getElementById('cookie-policy-view')
  cookieBanner.policyAcceptBtn = document.getElementById('cookie-policy-accept')
  cookieBanner.policyBackBtn = document.getElementById('cookie-policy-back')
  cookieBanner.policyCloseBtn = document.getElementById('cookie-policy-close')
  cookieBanner.cookieInfoToggleList = document.querySelectorAll('.js-cookie-info')
  cookieBanner.policyLinkList = document.querySelectorAll('.cookie-policy-link')
}

const setupEventListeners = () => {
  cookieBanner.consentAcceptBtn?.addEventListener('click', onAccept)
  cookieBanner.consentSettingsBtn?.addEventListener('click', onShowSettings)
  cookieBanner.consentDeclineBtn?.addEventListener('click', onDecline)
  cookieBanner.settingsSaveBtn?.addEventListener('click', onSave)
  cookieBanner.settingsBackBtn?.addEventListener('click', onBack)
  cookieBanner.policyAcceptBtn?.addEventListener('click', onAccept)
  cookieBanner.policyBackBtn?.addEventListener('click', onBack)
  cookieBanner.policyCloseBtn?.addEventListener('click', onClose)
  cookieBanner.policyLinkList?.forEach((link) => {
    link.addEventListener('click', onShowPolicy)
  })
  cookieBanner.cookieInfoToggleList?.forEach((toggle) => {
    toggle.addEventListener('click', onToggleInfo)
  })

  document.addEventListener('keydown', focusHandler)
}

const onSave = (e: MouseEvent) => {
  e.preventDefault()
  const cookieArr: string[] = []
  const inputs = document.querySelectorAll('#cookie-form input[type="checkbox"]') as NodeListOf<HTMLInputElement>

  inputs.forEach((input, i) => {
    const value = input.checked ? '1' : '0'
    cookieArr.push(`${consentGroups[i]}:${value}`)
  })

  const cookieString = cookieArr.join(',')

  cookies.set('ConsentCookie', cookieString, 365)
  setCookieSettings(cookieString)

  cookieBanner.banner!.style.display = 'none'
  location.reload()
}

const onAccept = (e: MouseEvent) => {
  e.preventDefault()

  const cookieString = consentGroups.map((group) => `${group}:1`).join(',')

  cookies.set('ConsentCookie', cookieString, 365)
  setCookieSettings(cookieString)

  cookieBanner.banner!.style.display = 'none'
  location.reload()
}

const onDecline = (e: MouseEvent) => {
  e.preventDefault()

  const cookieString = consentGroups.map((group, i) => `${group}:${i === 0 ? '1' : '0'}`).join(',')

  cookies.set('ConsentCookie', cookieString, 365)
  setCookieSettings(cookieString)
  cookieBanner.banner!.style.display = 'none'
}

const onShowSettings = (e: MouseEvent) => {
  e.preventDefault()

  cookieBanner.consentView!.style.display = 'none'
  cookieBanner.policyView!.style.display = 'none'
  cookieBanner.settingsView!.style.display = 'flex'
  cookieBanner.banner!.style.display = 'flex'
}

const onShowPolicy = (e: MouseEvent) => {
  e.preventDefault()

  cookieBanner.consentView!.style.display = 'none'
  cookieBanner.settingsView!.style.display = 'none'
  cookieBanner.policyView!.style.display = 'flex'

  if (!!cookies.get('ConsentCookie')) {
    cookieBanner.policyCloseBtn!.style.display = 'block'
    cookieBanner.policyAcceptBtn!.style.display = 'none'
  } else {
    cookieBanner.policyCloseBtn!.style.display = 'none'
    cookieBanner.policyAcceptBtn!.style.display = 'block'
  }

  cookieBanner.banner!.style.display = 'flex'
  cookieBanner.banner!.focus()
}

const onBack = (e: MouseEvent) => {
  e.preventDefault()

  cookieBanner.settingsView!.style.display = 'none'
  cookieBanner.policyView!.style.display = 'none'
  cookieBanner.consentView!.style.display = 'flex'
}

const onClose = (e: MouseEvent) => {
  e.preventDefault()

  cookieBanner.consentView!.style.display = 'none'
  cookieBanner.policyView!.style.display = 'none'
  cookieBanner.settingsView!.style.display = 'none'
  cookieBanner.banner!.style.display = 'none'
}

const onToggleInfo = (e: any) => {
  e.preventDefault()

  const toggle = e.currentTarget
  const infobox = toggle.nextElementSibling
  const isExpanded = toggle.getAttribute('aria-expanded') === 'true'

  if (isExpanded) {
    toggle.setAttribute('aria-expanded', 'false')
    toggle.classList.remove('minify')
    infobox.style.display = 'none'
  } else {
    toggle.setAttribute('aria-expanded', 'true')
    toggle.classList.add('minify')
    infobox.style.display = 'block'
  }
}

const focusHandler = (e: KeyboardEvent) => {
  const isTab = e.key === 'Tab'

  if (!isTab) return

  const withShift = e.shiftKey === true
  let activeView: HTMLElement

  if (!cookieBanner.consentView || !cookieBanner.policyView || !cookieBanner.settingsView) {
    return
  }

  if (!isHidden(cookieBanner.consentView)) {
    activeView = cookieBanner.consentView
  } else if (!isHidden(cookieBanner.policyView)) {
    activeView = cookieBanner.policyView
  } else if (!isHidden(cookieBanner.settingsView)) {
    activeView = cookieBanner.settingsView
  } else {
    return
  }

  const focusSel = 'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
  const focusable = activeView.querySelectorAll(focusSel) as NodeListOf<HTMLElement>

  if (withShift) {
    if (document.activeElement === focusable[0]) {
      focusable[focusable.length - 1].focus()
      e.preventDefault()
    }
  } else {
    if (document.activeElement === focusable[focusable.length - 1]) {
      focusable[0].focus()
      e.preventDefault()
    }
  }
}

const setCookieSettings = (cookie: string) => {
  const cookiearray = cookie.split(',')
  
  cookiearray.forEach((cookie: string, i) => {
    const val = cookie.split(':')[1]
    const checkbox = document.getElementById(`cookie-option-${i + 1}`) as HTMLInputElement
    checkbox.checked = val === '1'
  })
}

const isHidden = (el: HTMLElement) => {
  var style = window.getComputedStyle(el)
  return style.display === 'none'
}

const cookies = {
  set: (name: string, value: string, days: number) => {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/'
  },
  get: (name: string) => {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  },
}

;(() => {
  setupEventHandlers()
  setupEventListeners()

  if (!cookieBanner.banner) return

  const consentcookie = cookies.get('ConsentCookie')

  if (consentcookie) {
    cookieBanner.banner.style.display = 'none'
    setCookieSettings(consentcookie)
  } else {
    cookieBanner.banner.style.display = 'flex'
    cookieBanner.banner.focus()
  }
})()
